<template>
  <div v-if="$auth.check()">
    <dialog-loading v-if="!activeCompany && !has_companies"></dialog-loading>
    <div v-if="activeCompany">
      <v-navigation-drawer height="100%" v-model="drawer" app :mini-variant="!is_mobile" :clipped="!is_mobile" :permanent="!is_mobile" color="primary" dark :expand-on-hover="!is_mobile" >

      <!-- <v-navigation-drawer disable-resize-watcher v-model="drawer" clipped app> -->
        <template>
          
        </template>
        <v-list dense nav>
          <v-list-item
            active-class="primary white--text"
            two-line
            style="background: rgba(0,0,0,0.2);"
            v-if="activeCompanyId && user"
          >
            <v-list-item-action>
              <v-avatar  size="36" style="margin-left: -6px">
                <span v-if="profile_image_url == null" class="white--text text-h6">{{ initials }}</span>
                <v-img v-if="profile_image_url != null" :src="profile_image_url" />
              </v-avatar>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <b>{{profile_title}}</b>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{profile_subtitle}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-2"></v-divider>
          <v-list-item
            v-for="(link,i) in available_links_top"
            :key="i"
            :to="link.to"
            active-class="primary white--text"
          >
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              {{link.text}}
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <template v-slot:append>
          <v-list dense nav>
            <div class="px-0 pb-2" v-if="activeCompanyId">
              <v-divider class="mb-2"></v-divider>
              <v-list-item
                v-for="(link,i) in available_links_bottom"
                :key="i"
                :to="link.to"
                active-class="primary white--text"
              >
                <v-list-item-action>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  {{link.text}}
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-list>
        </template>
      </v-navigation-drawer>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { header, bottom, userBottom, userTop, super_admin_only } from "@/router/links";
import resize from "@/mixins/resize";
import Api from '@/api';

export default {
  name: 'Drawer',
  mixins: [resize],
  data() {
    return {
      links_top: header,
      links_bottom: bottom,
      links_user_bottom: userBottom,
      links_user_top: userTop,

      super_admin_only: super_admin_only,
    };
  },
  computed: {
    initials() {
      let name = this.$route.name == 'Account' ? this.user.name : this.activeCompany.name
      return name.match(/(^\S\S?|\s\S)?/g).map(v=>v.trim()).join("").match(/(^\S|\S$)?/g).join("").toLocaleUpperCase()
    },
    profile_image_url(){
      let url = this.$route.name == 'Account' ? this.user.avatar_url : this.activeCompany.logo_url
      return url
    },
    profile_title(){
      let url = this.$route.name == 'Account' ? this.user.name : this.activeCompany.name
      return url
    },
    profile_subtitle(){
      let url = this.$route.name == 'Account' ? this.user.email : this.activeCompany.main_email
      return url
    },
    has_companies(){
      return localStorage.has_companies
    },
    drawer: {
      get() {
        return this.$store.getters["App/getDrawer"];
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    available_links_top(){
      if (this.activeCompanyId){
        return this.$route.name == 'Account' ? this.links_user_top : this.links_top
      } else {
        let links = this.$route.name == 'Account' ? this.links_user_top : this.links_top
        return links.filter(l=> !l.needs_company)
      }
    },
    available_links_bottom(){
      if (this.activeCompanyId){
        let links = this.$route.name == 'Account' ? this.links_user_bottom : this.links_bottom
        if (this.user.my_roles.some((role) => role.name == 'super_admin')){
          links = [...links, ...this.super_admin_only]
        }
        return links
      } else {
        let links = this.$route.name == 'Account' ? this.links_user_bottom : this.links_bottom
        return links.filter(l=> !l.needs_company)
      }
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId,
      activeCompany: state => state.App.activeCompany,
      user: state => state.User.user
    })
  },
  methods: {
    ...mapMutations({
      setDrawer: "App/setDrawer",
      setActiveCompanyId: 'App/setActiveCompanyId'
    })
  },
};
</script>